/**
 * claim（宝の受け取り）継続用の共有定数。
 *
 * 未ログインで「受け取る」を押したユーザーは、OAuth 後に origin/chat へ戻る。
 * ClaimPage が token を保存し、App.js（Router 配下ラッパ）が認証確定後に検出して
 * /claim/:token へ戻す（Section 2.3 課題1）。両者でキーを共有しドリフトを防ぐ。
 */
export const PENDING_CLAIM_TOKEN_KEY = 'pendingClaimToken';
